module.exports = __webpack_public_path__ + "img/filter-welcome-background-infiniti.60c791b7.png";